module.exports = __webpack_public_path__ + "img/totally-radio-greatest-hits.8c8330f8.png";